<template>
  <div>
    <MainHeader />

    <section class="uk-section uk-container uk-padding-remove-bottom
    uk-padding-remove-top background-roos-brown uk-padding-remove">
      <USPCardContainer/>
    </section>

    <section class="uk-section uk-container background-neat-white max-width-unset
     uk-padding-remove-top">
      <div class="uk-padding-large">
        <div class="mijn-stem-demo-box">
          <div class="voice-demo-title">
            LUISTER NAAR VOORBEELDEN VAN
          </div>
          <div class="voice-demo-subtitle uk-margin-small-top">
            MIJN STEMDEMO’S
          </div>
            <audio-block></audio-block>
        </div>
        <div class="mijn-voice-over-werk-box">
          <div class="voice-demo-title">
            KIJK NAAR VOORBEELDEN VAN
          </div>
          <div class="voice-demo-subtitle uk-margin-small-top">
            MIJN VOICE-OVER WERK
          </div>
          <div class="video-flex uk-margin-medium-top">
            <div class="uk-flex uk-flex-column demo-images">
              <img src="../assets/images/pampers@2x.png">
              <div class="video-bar">
                <span class="video-pampers-span centered-text">PAMPERS RECLAME</span>
              </div>
              <a href="https://www.youtube.com/watch?v=3JnpuEe1Cd8" target="_blank" class="play-icon video-play-icon">
              <span>
                <img class="play-icon-video" src="../assets/images/icons/play-icon.svg">
              </span>
              </a>
            </div>
            <div class="uk-flex uk-flex-column demo-images demo-images-margin-mobile">
              <img src="../assets/images/hello-fresh@2x.png">
              <div class="video-bar">
                <span class="video-pampers-span centered-text">HELLO FRESH</span>
              </div>
              <a href="https://www.youtube.com/watch?v=Wep_MMp8guQ" target="_blank" class="play-icon video-play-icon">
              <span>
                <img class="play-icon-video" src="../assets/images/icons/play-icon.svg">
              </span>
              </a>
            </div>
            <div class="uk-flex uk-flex-column demo-images demo-images-margin-mobile">
              <img src="../assets/images/woonstad@2x.png">
              <div class="video-bar">
                <span class="video-pampers-span centered-text">FUNK-E | WOONSTAD</span>
              </div>
              <a href="https://www.youtube.com/watch?v=U4J0klritSk" target="_blank" class="play-icon video-play-icon">
              <span>
                <img class="play-icon-video" src="../assets/images/icons/play-icon.svg">
              </span>
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="uk-section uk-container-expand uk-margin-remove-top uk-padding-remove-top">
      <div class="uk-grid uk-grid-collapse">

        <div class="uk-cover-container uk-hidden@m">
          <canvas width="960" height="350"></canvas>
          <img
            :src="require('@/assets/images/rvdsb-5@small.png')"
            alt="Stemdemo"
            class=""
            uk-cover
          />
        </div>
        <image-section-tone-of-voice-text
          sub-title="Tone of Voice"
          title="Een voice-over op maat voor jou."
          button-text="Gratis stemdemo"
          button-link="/voice-over-aanvragen"
        >
          <div class="tone-of-voice-main-text">Ik zorg er voor dat ik samen met jou de juiste
            tone of voice vind die helemaal het gevoel geeft waar jij naar opzoek bent.
          </div>
          <br>
          <div class="tone-of-voice-sub-text">
            Een stem zegt alles en het is zo leuk om precies de goede tone of voice te vinden
            die helemaal aansluit bij het gevoel van het product. Vrolijk,
            zakelijk, betrouwbaar, enthousiast, stoer, vriendelijk of een combinatie daarvan.
            Alles is mogelijk.
          </div>
        </image-section-tone-of-voice-text>
        <div class="uk-width-1-2@m uk-cover-container uk-visible@m">
          <img
            :src="require('@/assets/images/rvdsb-5@2x.png')"
            alt="Stemdemo"
            class=""
          />
        </div>
        <div class="uk-width-1-2@m uk-visible@m">
          <img :src="require('@/assets/images/studio-background@2x.png')"
               alt="100% tevreden"
          />
        </div>
        <div class="uk-cover-container uk-hidden@m">
          <canvas width="960" height="300"></canvas>
          <img
            :src="require('@/assets/images/studio-background@small.png')"
            alt="Stemdemo"
            class=""
            uk-cover
          />
        </div>
        <image-section-ervaren-voice-over-text
          sub-title="Ervaren voice-over"
          title="Aan de slag in de studio."
          button-text="Ook tevreden worden?"
          :primary="true"
          button-link="/tevredenheid"
        >
          <div class="tone-of-voice-main-text">Ik beschik over een professionele geluid-studio en
            werk onder andere met Pro Tools.
          </div>
          <br>
          <div class="tone-of-voice-sub-text">
            De bestanden lever ik altijd schoon gesneden aan in WAV-formaat, tenzij anders gewenst.
            Het is niet nodig om aanwezig te zijn bij het inspreken,
            tenzij je dit natuurlijk graag wilt, dan maken we een afspraak.
          </div>
        </image-section-ervaren-voice-over-text>
        <div class="uk-cover-container uk-hidden@m">
          <canvas width="960" height="300"></canvas>
          <img
            :src="require('@/assets/images/thomas-le-b@small.png')"
            alt="Stemdemo"
            class=""
            uk-cover
          />
        </div>
        <image-section-interactive-voice-text
          sub-title="INTERACTIVE VOICE RESPONSE"
          title="Toets 1 voor voice-mail, meldteksten of mijn stem."
          button-text="Vraag een gratis sample aan"
          button-link="/voice-over-aanvragen"
        >
          <div class="interactive-voice-main-text">Ben je opzoek naar een stem voor je Interactive
            Voice Response of voicemail voor je bedrijf?
          </div>
          <br>
          <div class="interactive-voice-sub-text">
          Ook hier heb ik ervaring mee. Ik sta jouw klanten graag met een
          vriendelijke stem te woord.
          </div>
        </image-section-interactive-voice-text>
        <div class="uk-width-1-2@m uk-cover-container uk-visible@m">
          <img
            :src="require('@/assets/images/thomas-le-b@2x.png')"
            alt="Test - Test - 1, 2, 3. Staat dit ding wel aan?"
            class=""
          />
        </div>
        <div class="uk-cover-container uk-hidden@m">
          <canvas width="960" height="300"></canvas>
          <img
            :src="require('@/assets/images/indethuisstudio@small.png')"
            alt="Stemdemo"
            class=""
            uk-cover
          />
        </div>
        <div class="uk-width-1-2@m uk-visible@m">
          <img :src="require('@/assets/images/indethuisstudio@2x.png')"
               alt="Bliep - dit is een voice response"
          />
        </div>
        <image-section-mijn-tarieven-text
          sub-title="Mijn tarieven"
          title="Wat zijn de kosten van een voice-over?"
          button-text="Wil je een voorbeeld? Bel naar ..."
          :primary="true"
        >
          <div class="tone-of-voice-sub-text">
            De tarieven voor een voice-over zijn uiteenlopend; dit hangt onder andere af van het
            aantal woorden en het medium. Voor een voice-over voor televisie en radio reken ik
            bijvoorbeeld een ander tarief dan voor een corporate animatie.
            Neem gerust contact met mij op dan kunnen we alles bespreken.
          </div>
        </image-section-mijn-tarieven-text>
      </div>
    </section>

    <contact-form/>

    <section class="uk-container-expand uk-background-secondary">
      <div class="uk-container uk-padding-large">
        <h2 class="
            uk-heading-xsmall uk-text-uppercase
            uk-text-secondary no-border uk-text-light footer-inhuren-header"
        >WIL JE ROOS INHUREN ALS ACTRICE?</h2>
        <div class="uk-width-1-3@m uk-margin-auto uk-margin-remove-top">
          <p class="uk-text-secondary uk-text-center footer-inhuren-main">
            Neem contact op met: <br> Amber de Vente | Marble Agency
            <a href="mailto:info@marbleagency.amsterdam?SUBJECT=Inhuren Roos Netjes">
              info@marbleagency.amsterdam
            </a>
          </p>
          <div class="voice-over-button uk-display-block small-button-orange small-button-inhuren
          uk-margin-auto">
            <a href="http://marbleagency.amsterdam/" target="_blank"
               class="voice-over-button-clickable-section
            uk-display-block small-button-inhuren-text
            width-100-percent-important">
            <a class="voice-over-button-text
               small-button-orange-text text-transform-none small-button-inhuren-text
               marble-button-text">
                Naar de website van Marble
              </a>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import USPCardContainer from '@/components/USPCardContainer.vue';
import ImageSectionToneOfVoiceText from '@/components/ImageSectionToneOfVoiceText.vue';
import ImageSectionErvarenVoiceOverText from '@/components/ImageSectionErvarenVoiceOverText.vue';
import ImageSectionInteractiveVoiceText from '@/components/ImageSectionInteractiveVoiceText.vue';
import ImageSectionMijnTarievenText from '@/components/ImageSectionMijnTarievenText.vue';
import MainHeader from '@/components/MainHeader.vue';
import ContactForm from '@/components/ContactForm.vue';
import AudioBlock from '@/components/AudioBlock.vue';

export default {
  name: 'Main.vue',
  components: {
    USPCardContainer,
    ImageSectionToneOfVoiceText,
    ImageSectionErvarenVoiceOverText,
    ImageSectionInteractiveVoiceText,
    ImageSectionMijnTarievenText,
    MainHeader,
    ContactForm,
    AudioBlock,
  },
};
</script>
